import React, { useEffect, useState } from 'react';
import CampHeader from '../../header/CampHeader';
import CampHeaderGuest from '../../header/CampHeaderGuest';
import { useAuth } from '../../auth/Auth';
import RightWindowLeaf from '../../../assets/images/right-big-leaf.png';
import LeftWindowLeaf from '../../../assets/images/left-big-leaf.png';
import { nextChallengeViewModel } from '../next_challenge/next.challenge.viewmodel';
import KidsRoomTaleTree from '../my_room/kids-room/KidsRoomTaleTree';
import { useParams } from 'react-router-dom';
import { myRoomViewModel } from '../my_room/my.room.viewmodel';
import { useHistory } from 'react-router-dom';
import { DEPENDENT_TREE_ROUTE } from '../../../constants/routes.constants';
import Confetti from '../../common/animation/Confetti';
import EventEmitter from '../../../utils/events';
import { DEPENDENT_CREATION_OF_THE_DAY } from '../../../constants/companionPrompt.constants';

const KidsTaletree = () => {
  const history = useHistory();
  const { dependent, fetchAPI } = useAuth();
  const [dependentBranches, setDependentBranches] = useState([]);
  const [tagList, setTaglist] = useState([]);
  const [grassAnimationDisplay, setGrassAnimationDisplay] = useState('flex');
  const { id } = useParams();
  const [kidsData, setKidsData] = useState(null);
  const [isIdProcessed, setIsIdProcessed] = useState(false); // Tracks completion of the id effect
  const [isCreationOfTheDay, setIsCreationOfTheDay] = useState(false);
  const [showAnimation, setShowAnimation] = useState(false);
  const [creationOfTheDayId, setCreationOfTheDayId] = useState(null);
  const [updatedBranches, setUpdatedBranches] = useState([]);
  const getKidsData = () => {
    myRoomViewModel
      .getDependentUserByName(id)
      .then((res) => {
        setKidsData(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    if (id) {
      if (dependent) {
        if (id === dependent?.username) {
          setKidsData(dependent);
          checkCreationOfTheDay();
        } else {
          getKidsData();
        }
      } else {
        getKidsData();
      }
    } else {
      if (dependent?.username) {
        history.push(`${DEPENDENT_TREE_ROUTE}/${dependent?.username}`);
      }
    }
    setIsIdProcessed(true); // Mark id processing as complete
  }, [id, dependent]);

  const getBranchList = () => {
    myRoomViewModel
      .getCreatorInterests(kidsData?.username)
      .then((res) => {
        const storedBranches =
          JSON.parse(localStorage.getItem('previousBranches')) || [];
        const isFirstLoad =
          JSON.parse(localStorage.getItem('isFirstLoad')) || false;
        const addedBranches = (isFirstLoad === 'true' || isFirstLoad === true)
          ? res.filter(
              (branch) =>
                !storedBranches.some((b) => b.id === branch.id && branch)
            )
          : [];
        setUpdatedBranches(addedBranches);
        localStorage.setItem('previousBranches', JSON.stringify(res));
        localStorage.setItem('isFirstLoad', JSON.stringify(true));
        setDependentBranches(res);
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    getBranchList();
  }, []);

  const getTagList = () => {
    fetchAPI(nextChallengeViewModel.getTags, { limit: 10 })
      .then((res) => {
        setTaglist(res);
      })
      .catch((err) => {});
  };

  useEffect(() => {
    if (isIdProcessed) {
      if (kidsData?.id) {
        getBranchList();
      } else {
        getTagList();
      }
    }
  }, [kidsData, isIdProcessed]);

  useEffect(() => {
    setTimeout(() => {
      setGrassAnimationDisplay('none');
    }, [2000]);
    window.scrollTo(0, 0);
  }, []);

  const updateCreationOfTheDayAnimation = () => {
    if (creationOfTheDayId) {
      myRoomViewModel
        .updateCreationOfTheDayAnimation(creationOfTheDayId)
        .then((res) => {
          // EventEmitter.unsubscribe('show_prompt');
          // setShowAnimation(false);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const checkCreationOfTheDay = () => {
    myRoomViewModel
      .checkCreationOfTheDay()
      .then((res) => {
        if (res.length > 0) {
          let tempArr = res.filter((obj) => obj.is_animation === true);
          if (tempArr.length > 0) {
            setCreationOfTheDayId(tempArr[0]?.id);
            setIsCreationOfTheDay(true);
            setTimeout(() => {
              let promptData = {
                showPrompt: true,
                promptType: DEPENDENT_CREATION_OF_THE_DAY,
              };
              EventEmitter.dispatch('show_prompt', promptData);
            }, [3000]);
            setTimeout(() => {
              updateCreationOfTheDayAnimation();
            }, [5000]); // 5 seconds
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    if (showAnimation) {
      checkCreationOfTheDay();
    }
  }, [showAnimation]);

  return (
    <>
      {dependent ? <CampHeader /> : <CampHeaderGuest />}
      {isCreationOfTheDay && showAnimation && <Confetti />}
      <KidsRoomTaleTree
        branchesList={
          dependent
            ? dependentBranches.length > 0
              ? dependentBranches
              : tagList
            : dependentBranches.length > 0
            ? dependentBranches
            : tagList
        }
        isMyRoom={dependent && dependent?.username === id ? true : false}
        showAddButtons={dependent && dependent?.username === id ? true : false}
        isTreePage={true}
        kidsData={kidsData}
        setShowAnimation={setShowAnimation}
        updatedBranches={updatedBranches}
      />
      <div className="leafanimation" style={{ display: grassAnimationDisplay }}>
        <div className="box animate fadeInLeft three">
          <img src={RightWindowLeaf} className="leafanimationimg" />
        </div>

        <div className="box animate fadeInRight four">
          <img src={LeftWindowLeaf} className="leafanimationimg" />
        </div>
      </div>
    </>
  );
};

export default KidsTaletree;
